import { InjectionToken, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { getAjsProvider } from '@commons/core/core.provider.ajs';

import { Color, Tile, TILE_TOKEN, TileId, TileType, TRANSLATION_NS } from '@contact/upgrade';

import { IUserTrackingService } from './tracking.service';

export const NG1_USER_TRACKING_SEVICE = new InjectionToken<IUserTrackingService>('tracking');

@NgModule({})
export class TrackingForRootModule {
  constructor(@Optional() @SkipSelf() parentModule: TrackingForRootModule) {
    if (parentModule) throw new Error(`[TrackingForRootModule] module is already loaded`);
  }

  static instance(options: { path: string }): ModuleWithProviders<TrackingForRootModule> {
    return {
      ngModule: TrackingForRootModule,
      providers: [
        getAjsProvider(NG1_USER_TRACKING_SEVICE),

        {
          provide: TILE_TOKEN,
          useValue: {
            id: TileId.USER_TRACKING,
            type: TileType.STANDARD,
            icon: 'tile_user_tracking',
            color: Color.FUCHSIA,
            platforms: {
              desktop: {
                path: options.path,
              },
            },
            activePlatform: 'desktop',
          } as Tile,
          multi: true,
        },
        {
          provide: TRANSLATION_NS,
          useValue: 'tracking',
          multi: true,
        },
      ],
    };
  }
}
